import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="site-footer">
      <div className="site-footer__inner">
        <div>© 2026 Ayro</div>
        <div className="site-footer__links">
          <a href="/privacy/">Privacy Policy</a>
          <span>·</span>
          <a href="/terms/">Terms of Service</a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
